




























import { Component, Prop, Vue } from 'vue-property-decorator';
import MyWearables from '@/components/MyWearables.vue';
import AlpacaBtn from '@/components/AlpacaBtn.vue';
import { Wearable } from '@/backend/type';

@Component({
  components: {
    MyWearables,
    AlpacaBtn,
  },
})
export default class SelectScarfPopup extends Vue {
  @Prop({
    type: Boolean,
    required: true,
    default: false,
  })
  public value!: boolean;

  public changeState(state: boolean) {
    this.$emit('input', state);
  }

  public close() {
    this.changeState(false);
  }

  public clickWearableCard(wearable: Wearable) {
    this.$emit('clickWearableCard', wearable);
    this.close();
  }
}
